import axios from "axios";
import { toast } from "react-toastify";
import { API_URL, FOLDERPATH } from "../Constants/config";

import { handleApiError } from "../Helper/actionHelper";
import { EMPLOYMENT_DOCUMENT_FAILED, EMPLOYMENT_DOCUMENT_LOADING, EMPLOYMENT_DOCUMENT_SUCCESS, EXPERIENCE_OPTION_FAILED, EXPERIENCE_OPTION_LOADING, EXPERIENCE_OPTION_SUCCESS } from "../Constants/employmentConstants_v2";

const errorMsg = "Something went wrong. Please try again.";

export const getEmployementExperienceOptions = ( callback = () => {} ) => async (dispatch) => {
    try {
      let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));
      dispatch({ type: EXPERIENCE_OPTION_LOADING });
      const requestData = {
        token: userLocalData.id,
      };
  
      const headers = {
        "Content-Type": "application/json",
        Username: "ibridge",
        Password: "ibridge@2020",
      };
  
      const { data } = await axios.post(
        FOLDERPATH + "/EmploymentApi/getEmpOptions",
        requestData,
        {
          headers: headers,
        }
      );
        callback(data);
      dispatch({
        type: EXPERIENCE_OPTION_SUCCESS,
        payload: data,
      });
  
      handleApiError(data); //in case API return 200 with error details
    } catch (error) {
      toast.error(errorMsg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      dispatch({
        type: EXPERIENCE_OPTION_FAILED,
        payload:
          error.response && error.response.data.message
            ? error.response
            : error.response,
      });
  
      handleApiError(error);
    }
  };

  export const saveEmployementExperienceOption = ( option, callback = () => {} ) => async (dispatch) => {
    try {
      let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));
      dispatch({ type: EXPERIENCE_OPTION_LOADING });
      const requestData = {
        token: userLocalData.id,
        option,
      };
  
      const headers = {
        "Content-Type": "application/json",
        Username: "ibridge",
        Password: "ibridge@2020",
      };
  
      const { data } = await axios.post(
        FOLDERPATH + "/EmploymentApi/saveEmpOptions",
        requestData,
        {
          headers: headers,
        }
      );
        callback(data);
      dispatch({
        type: EXPERIENCE_OPTION_SUCCESS,
        payload: data,
      });
  
      handleApiError(data); //in case API return 200 with error details
    } catch (error) {
      toast.error(errorMsg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      dispatch({
        type: EXPERIENCE_OPTION_FAILED,
        payload:
          error.response && error.response.data.message
            ? error.response
            : error.response,
      });
  
      handleApiError(error);
    }
  };

  export const getEmploymentUpdatedDocuments = (callback = () => {}) => async (dispatch) => {
    try {
      let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));
      dispatch({ type: EMPLOYMENT_DOCUMENT_LOADING });
      const requestData = {
        token: userLocalData.id,
        group: 4,
        referenceNo: "1234567890",
      };
  
      const headers = {
        "Content-Type": "application/json",
        Username: "ibridge",
        Password: "ibridge@2020",
      };
  
      const { data } = await axios.post(
        FOLDERPATH + "/CandidateApi/checkDetail",
        requestData,
        {
          headers: headers,
        }
      );
  
      dispatch({
        type: EMPLOYMENT_DOCUMENT_SUCCESS,
        payload: data,
      });

      callback(data);
  
      handleApiError(data); //in case API return 200 with error details
    } catch (error) {
      toast.error(errorMsg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      dispatch({
        type: EMPLOYMENT_DOCUMENT_FAILED,
        payload:
          error.response && error.response.data.message
            ? error.response
            : error.response,
      });
  
      handleApiError(error);
    }
  };

  export const getEmploymentValidation = (caseCheckID, checkData, callback = () => {}) => async (dispatch) => {
    try {
      let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));
      dispatch({ type: EMPLOYMENT_DOCUMENT_LOADING });
      const requestData = {
        token: userLocalData.id,
        case_check_id: caseCheckID,
        check_data: checkData,
      };
  
      const headers = {
        "Content-Type": "application/json",
        Username: "ibridge",
        Password: "ibridge@2020",
      };
  
      const { data } = await axios.post(
        FOLDERPATH + "/EmploymentApi/validateEmp",
        requestData,
        {
          headers: headers,
        }
      );
  
      dispatch({
        type: EMPLOYMENT_DOCUMENT_SUCCESS,
        payload: data,
      });

      callback(data);
  
      handleApiError(data); //in case API return 200 with error details
      return data;
    } catch (error) {
      toast.error(errorMsg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      dispatch({
        type: EMPLOYMENT_DOCUMENT_FAILED,
        payload:
          error.response && error.response.data.message
            ? error.response
            : error.response,
      });
  
      handleApiError(error);
    }
  };

  export const getEmploymentGapReason = (caseCheckID, checkData, show_declaration, callback = () => {}) => async (dispatch) => {
    try {
      let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));
      dispatch({ type: EMPLOYMENT_DOCUMENT_LOADING });
      const requestData = {
        token: userLocalData.id,
        case_check_id: caseCheckID,
        check_data: checkData,
        show_declaration: show_declaration || 0,
      };
  
      const headers = {
        "Content-Type": "application/json",
        Username: "ibridge",
        Password: "ibridge@2020",
      };
  
      const { data } = await axios.post(
        FOLDERPATH + "/EmploymentApi/gapCheck",
        requestData,
        {
          headers: headers,
        }
      );
  
      dispatch({
        type: EMPLOYMENT_DOCUMENT_SUCCESS,
        payload: data,
      });

      callback(data);
      handleApiError(data); //in case API return 200 with error details
      return data;
    } catch (error) {
      toast.error(errorMsg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      dispatch({
        type: EMPLOYMENT_DOCUMENT_FAILED,
        payload:
          error.response && error.response.data.message
            ? error.response
            : error.response,
      });
  
      handleApiError(error);
    }
  };

  export const saveNoEmploymentReason = (payload = {}, callback = () => {}) => async (dispatch) => {
    try {
      let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));
      dispatch({ type: EMPLOYMENT_DOCUMENT_LOADING });
      const requestData = {
        token: userLocalData.id,
        ...payload
      };
  
      const headers = {
        "Content-Type": "application/json",
        Username: "ibridge",
        Password: "ibridge@2020",
      };
  
      const { data } = await axios.post(
        FOLDERPATH + "/EmploymentApi/saveEmploymentReason",
        requestData,
        {
          headers: headers,
        }
      );
  
      dispatch({
        type: EMPLOYMENT_DOCUMENT_SUCCESS,
        payload: data,
      });

      callback(data);
      handleApiError(data); //in case API return 200 with error details
      return data;
    } catch (error) {
      toast.error(errorMsg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      dispatch({
        type: EMPLOYMENT_DOCUMENT_FAILED,
        payload:
          error.response && error.response.data.message
            ? error.response
            : error.response,
      });
  
      handleApiError(error);
    }
  };

  export const getLocationOptions = (clientId, callback=()=>{}) => async (dispatch) => {
    try {
      let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));
      // dispatch({ type: EMPLOYMENT_LOADING });
      const requestData = {
        "client_id": clientId || ""
      };
  
      const headers = {
        "Content-Type": "application/json",
        Username: "ibridge",
        Password: "ibridge@2020",
      };
  
      const { data } = await axios.post(
        FOLDERPATH + "/GenericApi/getCompanyLocations",
        requestData,
        {
          headers: headers,
        }
      );
  
      // dispatch({
      //   type: EMPLOYMENT_SUCCESS,
      //   payload: data,
      // });
      callback(data?.data);
      handleApiError(data); //in case API return 200 with error details
    } catch (error) {
      toast.error(errorMsg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      // dispatch({
      //   // type: EMPLOYMENT_FAILED,
      //   payload:
      //     error.response && error.response.data.message
      //       ? error.response
      //       : error.response,
      // });
  
      handleApiError(error);
    }
  };

  
  export const saveEmplViaUANExperienceOption = ( payload = {}, callback = () => {} ) => async (dispatch) => {
    try {
      let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));
      dispatch({ type: EXPERIENCE_OPTION_LOADING });
      const requestData = {
        token: userLocalData.id,
        ...payload,
      };
  
      const headers = {
        "Content-Type": "application/json",
        Username: "ibridge",
        Password: "ibridge@2020",
      };
  
      const { data } = await axios.post(
        FOLDERPATH + "/CandidateApi/saveFresherDetails",
        requestData,
        {
          headers: headers,
        }
      );
        callback(data);
      dispatch({
        type: EXPERIENCE_OPTION_SUCCESS,
        payload: data,
      });
  
      handleApiError(data); //in case API return 200 with error details
    } catch (error) {
      toast.error(errorMsg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      dispatch({
        type: EXPERIENCE_OPTION_FAILED,
        payload:
          error.response && error.response.data.message
            ? error.response
            : error.response,
      });
  
      handleApiError(error);
    }
  };


  export const saveDateOfJoining = ( date = "", callback = () => {} ) => async (dispatch) => {
    try {
      let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));
      // dispatch({ type: EXPERIENCE_OPTION_LOADING });
      const requestData = {
        token: userLocalData.id,
        date_of_joinning : date
      };
  
      const headers = {
        "Content-Type": "application/json",
        Username: "ibridge",
        Password: "ibridge@2020",
      };
  
      const { data } = await axios.post(
        FOLDERPATH + "/EmploymentApi/saveDateOfJoining",
        requestData,
        {
          headers: headers,
        }
      );
        callback(data);
      // dispatch({
      //   type: EXPERIENCE_OPTION_SUCCESS,
      //   payload: data,
      // });
  
      handleApiError(data); //in case API return 200 with error details
    } catch (error) {
      toast.error(errorMsg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      // dispatch({
      //   type: EXPERIENCE_OPTION_FAILED,
      //   payload:
      //     error.response && error.response.data.message
      //       ? error.response
      //       : error.response,
      // });
  
      handleApiError(error);
    }
  };
